import { makeRequest } from "../helpers/api.helpers";

const API_URL = import.meta.env.VITE_API_URL;

export async function bindVehicleWithVelotrack(licensePlate: string) {
  const url = `${API_URL}/vehicles/bind-velotrack`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ licensePlate }),
  };

  return makeRequest<unknown>(url, options);
}
